export const categories = [
  {
    label: 'Лицо',
    href: '/catalog/face',
    children: [
      { label: 'Бестселлеры', href: '/catalog/face/bestsellers' },
      { label: 'Новинки', href: '/catalog/face/new' },
      { label: 'Увлажнение и питание', href: '/catalog/face/moisturizing' },
      { label: 'Очищение', href: '/catalog/face/cleansing' },
      { label: 'Защита от солнца', href: '/catalog/face/sun-protection' },
      { label: 'Тонизирование', href: '/catalog/face/toning' },
      { label: 'Маски', href: '/catalog/face/masks' },
      { label: 'Сыворотки', href: '/catalog/face/serums' },
      { label: 'Кремы', href: '/catalog/face/creams' },
      { label: 'Скрабы', href: '/catalog/face/scrubs' },
      { label: 'Моющие', href: '/catalog/face/washing' }
    ]
  },
  {
    label: 'Тело',
    href: '/catalog/body',
    children: [
      { label: 'Бестселлеры', href: '/catalog/body/bestsellers' },
      { label: 'Новинки', href: '/catalog/body/new' },
      { label: 'Увлажнение и питание', href: '/catalog/body/moisturizing' },
      { label: 'Очищение', href: '/catalog/body/cleansing' },
      { label: 'Защита от солнца', href: '/catalog/body/sun-protection' },
      { label: 'Пилинг', href: '/catalog/body/peeling' },
      { label: 'Антицеллюлит', href: '/catalog/body/anti-cellulite' },
      { label: 'Уход за руками', href: '/catalog/body/hand-care' },
      { label: 'Кремы', href: '/catalog/body/creams' },
      { label: 'Сыворотки', href: '/catalog/body/serums' },
      { label: 'Мыло', href: '/catalog/body/soap' },
      { label: 'Скраб', href: '/catalog/body/scrub' },
      { label: 'Моющие', href: '/catalog/body/washing' }
    ]
  },
  {
    label: 'Волосы и кожа головы',
    href: '/catalog/hair-and-scalp',
    children: [
      { label: 'Бестселлеры', href: '/catalog/hair-and-scalp/bestsellers' },
      { label: 'Новинки', href: '/catalog/hair-and-scalp/new' },
      { label: 'Шампуни', href: '/catalog/hair-and-scalp/shampoos' },
      { label: 'Уход для волос', href: '/catalog/hair-and-scalp/hair-care' }
    ]
  },
  {
    label: 'Тип кожи',
    href: '/catalog/skin-type',
    children: [
      { label: 'Жирная кожа', href: '/catalog/skin-type/oily' },
      { label: 'Сухая кожа', href: '/catalog/skin-type/dry' },
      { label: 'Чувствительная кожа', href: '/catalog/skin-type/sensitive' },
      { label: 'Нормальная кожа', href: '/catalog/skin-type/normal' },
      {
        label: 'Комбинированная кожа',
        href: '/catalog/skin-type/combination'
      },
      { label: 'Зрелая кожа', href: '/catalog/skin-type/mature' },
      { label: 'Проблемная кожа', href: '/catalog/skin-type/problematic' },
      { label: 'Атопичная кожа', href: '/catalog/skin-type/atopic' },
      {
        label: 'Кожа с гиперпигментацией',
        href: '/catalog/skin-type/hyperpigmentation'
      }
    ]
  },
  {
    label: 'Проблематика',
    href: '/catalog/problems',
    children: [
      { label: 'Акне', href: '/catalog/problems/acne' },
      { label: 'Купероз', href: '/catalog/problems/couperose' },
      { label: 'Сухость и шелушение', href: '/catalog/problems/dryness' },
      {
        label: 'Гиперпигментация',
        href: '/catalog/problems/hyperpigmentation'
      },
      { label: 'Розацеа', href: '/catalog/problems/rosacea' },
      { label: 'Пигментация', href: '/catalog/problems/pigmentation' },
      { label: 'Обезвоженность', href: '/catalog/problems/dehydration' },
      { label: 'Прыщи', href: '/catalog/problems/pimples' },
      { label: 'Возрастные изменения', href: '/catalog/problems/aging' },
      { label: 'Атопичная кожа', href: '/catalog/problems/atopic' },
      { label: 'Рубцы, шрамы', href: '/catalog/problems/scars' },
      { label: 'Пигментные пятна', href: '/catalog/problems/pigment-spots' }
    ]
  },
  {
    label: 'Тип средства',
    href: '/catalog/product-type',
    children: [
      { label: 'Маски', href: '/catalog/product-type/masks' },
      { label: 'Крем', href: '/catalog/product-type/cream' },
      { label: 'Сыворотка', href: '/catalog/product-type/serum' },
      { label: 'Гель', href: '/catalog/product-type/gel' },
      { label: 'Гель-крем', href: '/catalog/product-type/gel-cream' },
      { label: 'Бальзам', href: '/catalog/product-type/balm' },
      { label: 'Спрей', href: '/catalog/product-type/spray' },
      { label: 'Масло', href: '/catalog/product-type/oil' },
      { label: 'Молочко', href: '/catalog/product-type/milk' },
      { label: 'Шампунь', href: '/catalog/product-type/shampoo' },
      { label: 'Пенка', href: '/catalog/product-type/foam' },
      { label: 'Пена', href: '/catalog/product-type/mousse' }
    ]
  },
  {
    label: 'Защита от солнца',
    href: '/catalog/sun-protection',
    children: [
      { label: 'Защита от солнца', href: '/catalog/sun-protection/all' },
      { label: 'Все товары категории', href: '/catalog/sun-protection/all' },
      { label: 'Бестселлеры', href: '/catalog/sun-protection/bestsellers' },
      { label: 'Новинки', href: '/catalog/sun-protection/new' },
      {
        label: 'Солнцезащитные средства',
        href: '/catalog/sun-protection/sunscreen'
      },
      {
        label: 'Средства до загара',
        href: '/catalog/sun-protection/pre-tanning'
      },
      {
        label: 'Средства после загара',
        href: '/catalog/sun-protection/post-tanning'
      }
    ]
  },
  {
    label: 'Для детей',
    href: '/catalog/kids',
    children: [
      { label: 'Бестселлеры', href: '/catalog/kids/bestsellers' },
      { label: 'Новинки', href: '/catalog/kids/new' },
      { label: 'Атопичная кожа', href: '/catalog/kids/atopic' },
      { label: 'Очищение', href: '/catalog/kids/cleansing' },
      { label: 'Увлажнение и защита', href: '/catalog/kids/moisturizing' },
      { label: 'Защита от солнца', href: '/catalog/kids/sun-protection' }
    ]
  },
  { label: 'Наборы', href: '/catalog/sets' },
  { label: '💎 Акции', href: '/catalog/sale' }
];

export const brands = [
  {
    label: 'Bioderma',
    href: '/brand/bioderma',
    children: [
      { label: 'Бестселлеры', href: '/brand/bioderma/bestsellers' },
      { label: 'Новинки', href: '/brand/bioderma/new' },
      { label: 'Гель', href: '/brand/bioderma/gel' },
      { label: 'Для лица', href: '/brand/bioderma/face' },
      { label: 'Для тела', href: '/brand/bioderma/body' },
      { label: 'Очищение и уход', href: '/brand/bioderma/cleansing' },
      { label: 'Увлажнение и питание', href: '/brand/bioderma/moisturizing' },
      { label: 'Защита от солнца', href: '/brand/bioderma/sun-protection' },
      { label: 'Для волос', href: '/brand/bioderma/hair' },
      { label: 'Наборы', href: '/brand/bioderma/sets' }
    ]
  },
  {
    label: 'Institut Esthederm',
    href: '/brand/institut-esthederm',
    children: [
      { label: 'Бестселлеры', href: '/brand/institut-esthederm/bestsellers' },
      { label: 'Новинки', href: '/brand/institut-esthederm/new' },
      { label: 'Для лица', href: '/brand/institut-esthederm/face' },
      {
        label: 'Антивозрастной уход',
        href: '/brand/institut-esthederm/anti-aging'
      },
      {
        label: 'Очищение и уход',
        href: '/brand/institut-esthederm/cleansing'
      },
      {
        label: 'Увлажнение и питание',
        href: '/brand/institut-esthederm/moisturizing'
      },
      {
        label: 'Защита от солнца',
        href: '/brand/institut-esthederm/sun-protection'
      },
      { label: 'Для тела', href: '/brand/institut-esthederm/body' },
      { label: 'Для волос', href: '/brand/institut-esthederm/hair' },
      { label: 'Наборы', href: '/brand/institut-esthederm/sets' }
    ]
  },
  {
    label: 'Etat Pur',
    href: '/brand/etat-pur',
    children: [
      { label: 'Бестселлеры', href: '/brand/etat-pur/bestsellers' },
      { label: 'Новинки', href: '/brand/etat-pur/new' },
      { label: 'Очищение', href: '/brand/etat-pur/cleansing' },
      { label: 'Увлажнение', href: '/brand/etat-pur/moisturizing' },
      { label: 'Антивозрастной уход', href: '/brand/etat-pur/anti-aging' },
      { label: 'Наборы', href: '/brand/etat-pur/sets' }
    ]
  }
];

export const diagnosticArticles = [
  { label: 'Диагностика кожи', href: '/diagnostic' },
  { label: 'Найти врача', href: '/specialists' }
];

export const skinArticles = [
  { label: 'Здоровье кожи', href: '/skin' },
  { label: 'Образ жизни', href: '/skin' },
  { label: 'Что попробовать', href: '/skin' },
  { label: 'Акне', href: '/skin' },
  { label: 'Розацеа', href: '/skin' },
  { label: 'Атопический дерматит', href: '/skin' },
  { label: 'Пигментация', href: '/skin' },
  { label: 'Подкасты', href: '/skin' },
  { label: 'Интервью', href: '/skin' }
];

export const mobile = [
  { label: 'Каталог', href: '/', children: categories },
  { label: 'Подобрать уход', href: '/', children: diagnosticArticles },
  { label: 'Блог о коже', href: '/', children: skinArticles },
  { label: '💎 Акции', href: '/catalog/sale' }
];
